export default __webpack_public_path__ + "static/media/auglpm.b3babc34.png";